<template>
    <div id="app">
        <div class="card">
            <div class="c_bg">
                <img src="../assets/bg.png" alt="">
            </div>
            <div class="c_ct">
                <div class="c_img">
                    <img src="../assets/bbb.jpg" alt="">
                    <p>{{cardNo | cardNoChange}}</p>
                </div>
                <div  class="c_menu">
                    <div @click="busRocord" class="c_m">
                        <p><img src="../assets/ic_record.png" alt=""></p>
                        <p>乘车记录</p>
                    </div>
                    <div @click="toPath('order')" class="c_m">
                        <p><img src="../assets/ic_actualizar.png" alt=""></p>
                        <p>补登记录</p>
                    </div>
                    <div @click="refundCard" class="c_m">
                        <p><img src="../assets/ic_logout.png" alt=""></p>
                        <p>注销卡片</p>
                    </div>
                    <div @click="commonPath('line')" class="c_m">
                        <p><img src="../assets/ic_line.png" alt=""></p>
                        <p>开通线路</p>
                    </div>
                    <div @click="commonPath('help')" class="c_m">
                        <p><img src="../assets/ic_help.png" alt=""></p>
                        <p>使用帮助</p>
                    </div>
                </div>
                <div class="c_btn" @click="busSm">
                    去刷码
                </div>
            </div>
        </div>
    </div>
</template>

<script type="es6">
    import { MessageBox,Toast} from 'mint-ui';
    export default {
        name: 'app',
        data() {
            return {
                cardNo: "",
                role:"",
            }
        },
        mounted() {
            sessionStorage.setItem("urlParams",JSON.stringify(this.getQueryObject()))
            this.cardNo=this.getQueryObject().cardId;
            this.role=this.getQueryObject().hasRevoke;
            console.log(this.role)
        },
        filters:{
            cardNoChange(val){
                console.log(val)
                if(val){
                    return  val.replace(/(\d{4})(?=\d)/g,'$1 ')
                }
            }
        },
        methods:{
            getQueryObject (url) {
                url = url == null ? window.location.href : url
                var search = url.substring(url.lastIndexOf('?') + 1)
                var obj = {}
                var reg = /([^?&=]+)=([^?&=]*)/g
                search.replace(reg, function (rs, $1, $2) {
                    var name = decodeURIComponent($1)
                    var val = decodeURIComponent($2)
                    val = String(val)
                    obj[name] = val
                    return rs
                })
                return obj
            },
            //cardType:T0230100 测试  T1230100 生产
            busSm(){
                location.href="alipays://platformapi/startapp?appId=60000098&url=/www/offline_qrcode.html?cardType=T1230100&cardNo="+this.cardNo+"&source=coupon&__webview_options__=snapshot%3Dno%26transparentTitle%3Dauto%26canPullDown%3DNO";
            },
            busRocord(){
                location.href="alipays://platformapi/startapp?appId=20000076&returnHome=NO&extReq={\"cardType\": \"T1230100\"}&bizSubType=75;107&showSearch=false&title=乘车记录"
            },
            commonPath(path){
                this.$router.push({path:path})
            },
            toPath(path){
                var query;
                if(window.location.href.indexOf("cardId")>-1&&window.location.href.indexOf("accessToken")>-1){
                    query=this.getQueryObject();
                }else{
                    Toast("参数不完整");
                    return
                }
                this.$router.push({path:path,query:{cardId:query.cardId,accessToken:query.accessToken}})
            },
            refundCard(){
                var msg=this.getQueryObject().revokeMsg
                if(this.role=='true'){
                    Toast("您已申请退卡,不能重复退卡");
                    return
                }else{
                    MessageBox.confirm(msg).then(action => {
                        var query;
                        if(window.location.href.indexOf("cardId")>-1&&window.location.href.indexOf("accessToken")>-1){
                            query=this.getQueryObject();
                        }else{
                            Toast("参数不完整");
                            return
                        }
                        this.$ajax({
                            method: 'post',
                            headers: {
                                'Content-Type': 'application/json;charset=UTF-8'
                            },
                            url: 'cst/applet/alipay/userCancelAjax',
                            params: {
                                "app_id":query.app_id,
                                "cardId":query.cardId,
                                "user_id":query.user_id,
                                "accessToken":query.accessToken,
                            }
                        }).then(
                            (res) => {
                                console.log(res)
                                if (res.data.code=="0000") {
                                    Toast(res.data.message);
                                } else {
                                    Toast(res.data.message);
                                }
                            }
                        ).catch((res) => {

                            }
                        )
                    });
                }


            }

        }
    }
</script>

<style scoped>
    p{
        margin: 0;
        padding: 0;
    }
    .card {
        position: relative;

    }

    .c_bg img {
        width: 100%;
    }

    .c_ct {
        position: absolute;
        top: 90px;
        left: 0;
        width: 100%;
        padding: 15px;
        box-sizing: border-box;
    }

    .c_img {
        position: relative;
    }

    .c_img img {
        width: 100%;
    }

    .c_img p {
        position: absolute;
        top: 20px;
        left: 16px;
        width: auto;
        height: 60px;
        line-height: 60px;
        color: #000;
        padding-right: 20px;
        text-align: left;
        font-size: 13px;
        /*border-bottom-right-radius:5px;*/
        /*border-bottom-left-radius:5px;*/
        /*box-sizing: border-box;*/
    }
    .c_menu{
        overflow: hidden;
        padding: 10px 0;
    }
    .c_m{
        float: left;
        width: 33.3%;
        text-align: center;
        padding-top: 30px

    }
    .c_m p img{
        width: 24px;
        height: 28px;
    }
    .c_m p:nth-child(2){
        font-size: 14px;
        padding: 12px 0;
        color: #333;
    }

    .c_btn{
        margin-top: 20px;
        display: block;
        background: #0096F8;
        border-radius: 5px;
        font-size: 16px;
        padding: 12px;
        text-align: center;
        color: #fff;
    }
</style>



// WEBPACK FOOTER //
// src/components/home.vue